import { FC, CSSProperties } from "react";
import classNames from "classnames";

import { StyledLoadingMessage } from "@app/components/common/LoadingElement.styles";
import { SHOW_LOADING_MESSAGES } from "@app/core/loading/LoadingContext";

import { Spinner } from "@dit/ui-components.react.element.spinner";
import { isNullOrWhitespace } from "@app/core/utilities/string";
import { useDataId } from "@dit/ui-core-hooks";
import { getDebugLogger } from "@app/core/devtools";

const log = getDebugLogger("render:flow");

type Props = {
    loadingMessage?: string;
    size?: number;
    className?: string;
    strokeColor?: string;
};

export const LoadingElement: FC<Props> = ({ loadingMessage, size = 50, className, strokeColor }) => {
    const { getManualId } = useDataId(LoadingElement);
    const showMessage = SHOW_LOADING_MESSAGES && !isNullOrWhitespace(loadingMessage);

    log("LoadingElement-render", { loadingMessage, showMessage, SHOW_LOADING_MESSAGES });

    const spinnerClass = strokeColor ? "current-color" : "";

    return (
        <>
            <Spinner
                data-id={getManualId("loader")}
                className={classNames("loading-element", spinnerClass, className)}
                size={size}
                style={strokeColor ? ({ color: strokeColor } as CSSProperties) : undefined}
                aria-label="Loading"
            />
            {showMessage && <StyledLoadingMessage>{loadingMessage}</StyledLoadingMessage>}
        </>
    );
};
